"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AsyncScheduler_1 = require("../scheduler/AsyncScheduler");

var IntervalScheduler_1 = require("../scheduler/IntervalScheduler");

var SignalingClientEventType_1 = require("../signalingclient/SignalingClientEventType");

var SignalingProtocol_js_1 = require("../signalingprotocol/SignalingProtocol.js");

var Types_1 = require("../utils/Types");
/**
 * [[DefaultPingPong]] implements the PingPong and SignalingClientObserver interface.
 */


var DefaultPingPong = /*#__PURE__*/function () {
  function DefaultPingPong(signalingClient, intervalMs, logger) {
    _classCallCheck(this, DefaultPingPong);

    this.signalingClient = signalingClient;
    this.intervalMs = intervalMs;
    this.logger = logger;
    this.observerQueue = new Set();
    this.consecutivePongsUnaccountedFor = 0;
    this.intervalScheduler = new IntervalScheduler_1.default(this.intervalMs);
    this.pingId = 0;
  }

  _createClass(DefaultPingPong, [{
    key: "addObserver",
    value: function addObserver(observer) {
      this.logger.info('adding a ping-pong observer');
      this.observerQueue.add(observer);
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.logger.info('removing a ping-pong observer');
      this.observerQueue.delete(observer);
    }
  }, {
    key: "forEachObserver",
    value: function forEachObserver(observerFunc) {
      var _this = this;

      var _iterator = _createForOfIteratorHelper(this.observerQueue),
          _step;

      try {
        var _loop = function _loop() {
          var observer = _step.value;
          AsyncScheduler_1.default.nextTick(function () {
            if (_this.observerQueue.has(observer)) {
              observerFunc(observer);
            }
          });
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "start",
    value: function start() {
      this.stop();
      this.signalingClient.registerObserver(this);

      if (this.signalingClient.ready()) {
        this.startPingInterval();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.stopPingInterval();
      this.signalingClient.removeObserver(this);
    }
  }, {
    key: "startPingInterval",
    value: function startPingInterval() {
      var _this2 = this;

      this.intervalScheduler.start(function () {
        _this2.ping();
      });
      this.ping();
    }
  }, {
    key: "stopPingInterval",
    value: function stopPingInterval() {
      this.intervalScheduler.stop();
      this.pingId = 0;
      this.consecutivePongsUnaccountedFor = 0;
    }
  }, {
    key: "ping",
    value: function ping() {
      var _this3 = this;

      if (this.consecutivePongsUnaccountedFor > 0) {
        this.logger.warn("missed pong ".concat(this.consecutivePongsUnaccountedFor, " time(s)"));
        this.forEachObserver(function (observer) {
          Types_1.Maybe.of(observer.didMissPongs).map(function (f) {
            return f.bind(observer)(_this3.consecutivePongsUnaccountedFor);
          });
        });
      }

      this.consecutivePongsUnaccountedFor += 1;
      this.pingId = this.pingId + 1 & 0xffffffff;
      var ping = SignalingProtocol_js_1.SdkPingPongFrame.create();
      ping.pingId = this.pingId;
      ping.type = SignalingProtocol_js_1.SdkPingPongType.PING;
      this.pingTimestampLocalMs = this.signalingClient.pingPong(ping);
      this.logger.debug(function () {
        return "sent ping ".concat(_this3.pingId);
      });
    }
  }, {
    key: "pong",
    value: function pong(pingId) {
      var pong = SignalingProtocol_js_1.SdkPingPongFrame.create();
      pong.pingId = pingId;
      pong.type = SignalingProtocol_js_1.SdkPingPongType.PONG;
      this.signalingClient.pingPong(pong);
    }
  }, {
    key: "handleSignalingClientEvent",
    value: function handleSignalingClientEvent(event) {
      switch (event.type) {
        case SignalingClientEventType_1.default.WebSocketOpen:
          this.startPingInterval();
          break;

        case SignalingClientEventType_1.default.WebSocketFailed:
        case SignalingClientEventType_1.default.WebSocketError:
          this.logger.warn("stopped pinging (".concat(SignalingClientEventType_1.default[event.type], ")"));
          this.stopPingInterval();
          break;

        case SignalingClientEventType_1.default.WebSocketClosing:
        case SignalingClientEventType_1.default.WebSocketClosed:
          this.logger.info("stopped pinging (".concat(SignalingClientEventType_1.default[event.type], ")"));
          this.stopPingInterval();
          break;

        case SignalingClientEventType_1.default.ReceivedSignalFrame:
          if (event.message.type !== SignalingProtocol_js_1.SdkSignalFrame.Type.PING_PONG) {
            break;
          }

          if (event.message.pingPong.type === SignalingProtocol_js_1.SdkPingPongType.PONG) {
            var pingId = event.message.pingPong.pingId;

            if (pingId !== this.pingId) {
              this.logger.warn("unexpected ping id ".concat(pingId, " (expected ").concat(this.pingId, ")"));
              break;
            }

            this.consecutivePongsUnaccountedFor = 0;
            var pongTimestampRemoteMs;

            if (typeof event.message.timestampMs === 'number') {
              pongTimestampRemoteMs = event.message.timestampMs;
            } else {
              break;
            }

            this.logger.debug(function () {
              return "received pong ".concat(pingId, " with timestamp ").concat(pongTimestampRemoteMs);
            });
            var pongTimestampLocalMs = event.timestampMs;
            var pingPongLocalIntervalMs = pongTimestampLocalMs - this.pingTimestampLocalMs;
            var estimatedPingTimestampRemoteMs = Math.round(pongTimestampRemoteMs - pingPongLocalIntervalMs / 2);
            var estimatedClockSkewMs = this.pingTimestampLocalMs - estimatedPingTimestampRemoteMs;
            this.logger.info("local clock skew estimate=".concat(estimatedClockSkewMs, "ms from ping-pong time=").concat(pingPongLocalIntervalMs, "ms"));
            this.forEachObserver(function (observer) {
              Types_1.Maybe.of(observer.didReceivePong).map(function (f) {
                return f.bind(observer)(pingId, estimatedClockSkewMs, pingPongLocalIntervalMs);
              });
            });
          } else {
            this.pong(event.message.pingPong.pingId);
          }

          break;
      }
    }
  }]);

  return DefaultPingPong;
}();

exports.default = DefaultPingPong;